import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getToolTipAttributes } from "../../../utils/tooltip";

const ToolBox = ({ selectedItem, onDuplicate, onCopy, onPaste, onDelete, onCut }) => {
  const showPaste = ["section", "block", "column"].includes(selectedItem?.type);
  const showCutAndCopy = !["section", "full"].includes(selectedItem?.type);
  return (
    <div className="d_flex gap_1 mt_1 ml_3">
      <MaterialIcon
        name="file_copy"
        className="font_size_medium"
        disabled={!selectedItem}
        onClick={() => onDuplicate(selectedItem)}
        {...getToolTipAttributes("Duplicate", "bottom")}
      />
      {showCutAndCopy && (
        <>
          <MaterialIcon
            name="content_copy"
            className="font_size_medium"
            disabled={!selectedItem}
            onClick={() => onCopy(selectedItem)}
            {...getToolTipAttributes("Copy", "bottom")}
          />
          <MaterialIcon
            name="cut"
            className="font_size_medium"
            disabled={!selectedItem}
            onClick={() => onCut(selectedItem)}
            {...getToolTipAttributes("Cut", "bottom")}
          />
        </>
      )}
      {showPaste && (
        <MaterialIcon
          name="content_paste"
          onClick={() => onPaste(selectedItem)}
          disabled={!selectedItem}
          className="font_size_medium"
          {...getToolTipAttributes("Paste", "bottom")}
        />
      )}
      <MaterialIcon
        name="delete"
        onClick={() => onDelete(selectedItem)}
        disabled={!selectedItem}
        className="font_size_medium"
        {...getToolTipAttributes("Delete", "bottom")}
      />
    </div>
  );
};

export default ToolBox;
